import _createForOfIteratorHelper from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import React from 'react';
import { Box, Group, Button } from '@mantine/core';
import { useModals } from './use-modals/use-modals.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

function ConfirmModal(_ref) {
  var id = _ref.id,
      cancelProps = _ref.cancelProps,
      confirmProps = _ref.confirmProps,
      _ref$labels = _ref.labels,
      labels = _ref$labels === void 0 ? {
    cancel: "",
    confirm: ""
  } : _ref$labels,
      _ref$closeOnConfirm = _ref.closeOnConfirm,
      closeOnConfirm = _ref$closeOnConfirm === void 0 ? true : _ref$closeOnConfirm,
      _ref$closeOnCancel = _ref.closeOnCancel,
      closeOnCancel = _ref$closeOnCancel === void 0 ? true : _ref$closeOnCancel,
      groupProps = _ref.groupProps,
      onCancel = _ref.onCancel,
      onConfirm = _ref.onConfirm,
      children = _ref.children;
  var cancelLabel = labels.cancel,
      confirmLabel = labels.confirm;
  var ctx = useModals();

  var handleCancel = function handleCancel(event) {
    typeof (cancelProps == null ? void 0 : cancelProps.onClick) === "function" && (cancelProps == null ? void 0 : cancelProps.onClick(event));
    typeof onCancel === "function" && onCancel();
    closeOnCancel && ctx.closeModal(id);
  };

  var handleConfirm = function handleConfirm(event) {
    typeof (confirmProps == null ? void 0 : confirmProps.onClick) === "function" && (confirmProps == null ? void 0 : confirmProps.onClick(event));
    typeof onConfirm === "function" && onConfirm();
    closeOnConfirm && ctx.closeModal(id);
  };

  return /* @__PURE__ */React.createElement(React.Fragment, null, children && /* @__PURE__ */React.createElement(Box, {
    mb: "md"
  }, children), /* @__PURE__ */React.createElement(Group, __spreadValues({
    position: "right"
  }, groupProps), /* @__PURE__ */React.createElement(Button, __spreadProps(__spreadValues({
    variant: "default"
  }, cancelProps), {
    onClick: handleCancel
  }), (cancelProps == null ? void 0 : cancelProps.children) || cancelLabel), /* @__PURE__ */React.createElement(Button, __spreadProps(__spreadValues({}, confirmProps), {
    onClick: handleConfirm
  }), (confirmProps == null ? void 0 : confirmProps.children) || confirmLabel)));
}

export { ConfirmModal };